<script lang="ts" setup>
import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "vue";

const props = defineProps<{
	class?: HTMLAttributes["class"];
}>();
</script>

<template>
	<span
		role="link"
		aria-disabled="true"
		aria-current="page"
		:class="twMerge('font-normal text-foreground', props.class)"
	>
		<slot />
	</span>
</template>
